/**
 * Reducer for managing versions of a kit.
 */

import _merge from "lodash/merge";

import * as actionTypes from "../../actions/actionTypes";

const kitVersionReducer = (state = {}, action) => {
  let kitVersions;
  try {
    kitVersions = action.response.entities.kitVersions;
  } catch (error) {
    // That's ok
  }

  switch (action.type) {
    case actionTypes.DELETE_KIT_VERSION_SUCCESS: {
      const newState = Object.assign({}, state);
      delete newState[`${action.uuid}-${action.version}`];
      return newState;
    }
    case actionTypes.DELETE_SECTION_SUCCESS: {
      const sectionId = action.response.result;
      const { kitId } = action.response.entities.sections[sectionId],
        versionedKit = `${kitId}-0`;

      const newSections = [...state[versionedKit].sections];
      newSections.splice(newSections.indexOf(sectionId), 1);

      const newState = {
        ...state,
        [versionedKit]: {
          ...state[versionedKit],
          sections: newSections,
        },
      };
      return newState;
    }
    case actionTypes.MOVE_SECTION_SUCCESS: {
      const { sectionUuid, fromKitUuid } = action;

      const versionedKitId = `${fromKitUuid}-0`,
        versionedSectionUuid = `${sectionUuid}-0`;

      const newSections = [...state[versionedKitId].sections];
      newSections.splice(newSections.indexOf(versionedSectionUuid), 1);

      const newState = {
        ...state,
        [versionedKitId]: {
          ...state[versionedKitId],
          sections: newSections,
        },
      };
      return newState;
    }
    case actionTypes.CREATE_SECTION_SUCCESS: {
      const {
          kitId,
          response: { result },
        } = action,
        versionedKitId = `${kitId}-0`,
        oldSections = state[versionedKitId].sections;
      return _merge({}, state, {
        [versionedKitId]: { sections: [...oldSections, result] },
      });
    }
    case actionTypes.BATCH_UPDATE_ITEM_STATUS_SUCCESS: {
      if (!action.response.entities.items) return state;

      const successfulItems = action.response.result.items.filter(i => i.success).map(i => i.item);
      if (!successfulItems.length) return state;

      const newState = { ...state };
      const { entities } = action.response;
      successfulItems.forEach(id => {
        const fullItem = entities.items[id],
          { kitId, version, status, sectionId } = fullItem,
          versionedId = `${kitId}-${version}`;

        const oldTrash = newState[versionedId].counts.trash,
          newTrash = oldTrash + (status === "trashed" ? 1 : -1);
        const oldRecovery = newState[versionedId].counts.recovery,
          newRecovery = oldRecovery + (!sectionId ? 1 : 0);

        newState[versionedId] = _merge({}, newState[versionedId], {
          counts: { trash: newTrash, recovery: newRecovery },
        });
      });

      return newState;
    }
    case actionTypes.CLEAR_ALL_RECENTLY_DELETED_SUCCESS:
      return _merge({}, state, { [`${action.uuid}-0`]: { counts: { trash: 0 } } });
    case actionTypes.DUPLICATE_KIT_SUCCESS:
      // Don't insert the draft for the duplicate into state
      return state;
    // Defaults
    case actionTypes.FETCH_KIT_SUCCESS:
    case actionTypes.FETCH_KIT_OUTLINE_SUCCESS:
    case actionTypes.CREATE_KIT_VERSION_SUCCESS:
    case actionTypes.FETCH_KIT_VERSION_SUCCESS:
    case actionTypes.EDIT_KIT_VERSION_SUCCESS:
    default: {
      if (kitVersions) return _merge({}, state, kitVersions);
      return state;
    }
  }
};

export default kitVersionReducer;
